export default "<div class=\"row\">\n  <div class=\"col\">\n    <p>{{message}}</p>\n  </div>\n</div>\n"